import React from "react";
import { Paper, Typography, Box, useTheme } from "@mui/material";
import { IconTitle, ArticleCustomIcon } from "../ui/UserIcons";
import RecipeCard from "./RecipeCard";

interface Recipe {
  _id: string;
  name: string;
  status: string;
  status_name: string;
  created_at_name: string;
  data: {
    coverImage?: {
      source: string;
    };
  };
}

interface RecipesSectionProps {
  recipes: Recipe[];
  onRecipeClick: (recipeId: string) => void;
}

const RecipesSection: React.FC<RecipesSectionProps> = ({
  recipes,
  onRecipeClick,
}) => {
  const theme = useTheme();

  return (
    <Paper elevation={0} sx={{ p: 3 }}>
      <IconTitle
        Icon={ArticleCustomIcon}
        title="Recipes & Contributions"
        color={theme.palette.materiom.seaweed}
      />

      {recipes.length > 0 ? (
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              sm: "1fr 1fr",
              lg: "1fr 1fr 1fr",
            },
            gap: 3,
          }}
        >
          {recipes.map((recipe) => (
            <RecipeCard
              key={recipe._id}
              recipe={recipe}
              onRecipeClick={onRecipeClick}
            />
          ))}
        </Box>
      ) : (
        <Box sx={{ textAlign: "center", py: 4 }}>
          <Typography
            variant="body1"
            color="text.secondary"
            sx={{ fontWeight: 500, opacity: 0.7 }}
          >
            This user hasn't contributed any recipes yet! Check back soon.
          </Typography>
        </Box>
      )}
    </Paper>
  );
};

export default RecipesSection;
